<div [hidden]="!isDelayedRunning" class="spinner">
  <div class="double-bounce1"></div>
  <div class="double-bounce2"></div>
</div>
